import { render, staticRenderFns } from "./elementBuilder.vue?vue&type=template&id=68caacc4"
import script from "./elementBuilder.vue?vue&type=script&lang=js"
export * from "./elementBuilder.vue?vue&type=script&lang=js"
import style0 from "./elementBuilder.vue?vue&type=style&index=0&id=68caacc4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports